import React from 'react';

import { Box } from '@mui/material';
import Moment from 'moment';

import { type ContentItem } from './types';

interface Props {
    item: ContentItem;
    format: 'json' | 'text';
}

const ClassEvent: React.FC<Props> = ({ item, format }) => {
    if (format === 'text') {
        return (
            <div style={{ color: 'rgb(255, 255, 255)' }}>
                {Moment(new Date(item.timestamp)).format('h:mm A')}: {item.text_content}
            </div>
        );
    }
    const fromElement = (
        <>
            <div
                style={{
                    position: 'absolute',
                    top: '5px',
                    right: '5px',
                    fontSize: '10px',
                    color: 'rgb(255, 255, 255)'
                }}
            >
                {Moment(new Date(item.timestamp)).format('h:mm A')}
            </div>
        </>
    );
    return (
        <Box
            sx={{
                position: 'relative',
                fontFamily: 'Lato',
                fontWeight: 'bold',
                fontSize: '12px',
                marginBottom: '16px',
                width: '100%',
                padding: '12px',
                backgroundColor: '#4739e7',
                color: 'rgb(255, 255, 255)',
                borderRadius: '12px'
            }}
        >
            {fromElement}
            <div
                style={{
                    fontSize: '13px',
                    position: 'relative',
                    left: '0px',
                    width: 'calc(100% - 0px)',
                    color: 'rgb(255, 255, 255)',
                    lineHeight: '1.0'
                }}
            >
                <div>{item.text_content}</div>
            </div>
        </Box>
    );
};

export default ClassEvent;
